module.exports = __webpack_public_path__ + "static/media/proa_113.7ab94dda.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/climb/proa_113.jpg
// module id = 126
// module chunks = 0